import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { Box } from "@material-ui/core";
import { useVerticalNav } from "../../../../../../Contexts/VerticalNavContext";
import { UpdateAgentCommissionTransaction } from "../../../../../../Services";
import { getStatus } from "../../../util";

import Tabs, { TabPanel } from "../../Tabs/Tabs";
import Invoice from "../../Invoice/Invoice";
import { useTranslate } from "../../../../../../Hooks";

import useStyles from "./styles";

function AgentCommissionNestedMenu({
  selectedTransaction,
  isOpen,
  tabs,
  setTabs,
  refetchdata,
}) {
  const { isDarkMode } = useSelector((state) => state.theme);

  const styles = useStyles({ isDarkMode });
  const { setAlertBoxContent } = useVerticalNav();
  const [tabValue, setTabValue] = useState(0);
  const { translate } = useTranslate("AgentCommissionView");
  const [isInvoiceValid, setIsInvouiceValid] = useState(false);
  const [formValue, setFormValue] = useState({
    invoicesNumber: "",
    voucherNumber: "",
    invoiceStatus: "",
    collectionStatus: "",
    paymentStatus: "",
    agencyFeesRate: 0,
    agentCommissionRate: 0,
    deduction: 0,
    totalDealExpense: 0,
    adminFees: 0,
    listingCommission: 0,
    telesalesCommission: 0,
    coordinatorCommission: 0,
    tlCommissionRate: 0,
    smCommissionRate: 0,
  });
  const [updatedInvoice, setUpdatedInvoice] = useState([]);

  const handleUpdateInvoice = async (updatedTabs) => {
    const transaction = { ...selectedTransaction };
    delete transaction.agentId;
    const res = await UpdateAgentCommissionTransaction(
      {
        ...transaction,
        invoices: updatedTabs.map((tab, index) => ({
          agentAchievementCommissionInvoiceId:
            tab.agentAchievementCommissionInvoiceId ||
            updatedInvoice[index]?.agentAchievementCommissionInvoiceId ||
            0,
          invoicesNumber: tab.invoicesNumber || 0,
          voucherNumber: tab.voucherNumber || 0,
          invoiceStatus: getStatus(tab.invoiceStatus?.lookupItemName || 0),
          collectionStatus: getStatus(
            tab.collectionStatus?.lookupItemName || 0
          ),
          paymentStatus: getStatus(tab.paymentStatus?.lookupItemName || 0),
          agencyFeesRate: tab.agencyFeesRate || 0,
          agentCommissionRate: tab.agentCommissionRate || 0,
          deduction: tab.deduction || 0,
          totalDealExpense: tab.totalDealExpense || 0,
          adminFees: tab.adminFees || 0,
          listingCommission: tab.listingCommission || 0,
          telesalesCommission: tab.telesalesCommission || 0,
          coordinatorCommission: tab.coordinatorCommission || 0,
          tlCommissionRate: tab.tlCommissionRate || 0,
          smCommissionRate: tab.smCommissionRate || 0,
        })),
      },
      selectedTransaction.agentId
    );
    if (!(res?.status && res.status !== 200)) {
      refetchdata();
      setUpdatedInvoice(
        res.result.find(
          (item) => item.transactionID === selectedTransaction?.transactionID
        )?.invoices || []
      );
      return setAlertBoxContent({
        display: true,
        variant: "success",
        title: translate("transaction-updated-successfully"),
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
    return setAlertBoxContent({
      display: true,
      variant: "error",
      title: translate("transaction-updated-error"),
      onClose: () => {
        setAlertBoxContent(null);
      },
    });
  };

  const onSave = async () => {
    const filteredTabs = tabs.filter((_, index) => index !== tabValue);
    const updatedTabs = [
      ...filteredTabs,
      { ...tabs[tabValue], ...formValue },
    ].sort((a, b) => a.id - b.id);

    await handleUpdateInvoice(updatedTabs);
  };

  const handleTabChange = (_e, newValue) => {
    const newTabs = tabs.filter((_, index) => index !== tabValue);
    setTabs(
      [...newTabs, { ...tabs[tabValue], ...formValue }].sort(
        (a, b) => a.id - b.id
      )
    );
    setTabValue(newValue);
  };
  const handleAddTab = () => {
    if (isInvoiceValid) {
      return setTabs([
        ...tabs,
        {
          label: translate("invoice") + ` ${tabs.length + 1}`,
          id: tabs.length + 1,
        },
      ]);
    }
    setAlertBoxContent({
      display: true,
      variant: "error",
      title: translate("please-fill-required-fields-before-adding-new-invoice"),
      onClose: () => {
        setAlertBoxContent(null);
      },
    });
  };
  const validateFields = (formValue) => {
    if (!selectedTransaction) return {};
    const { finalNetAmount } = selectedTransaction;
    const errors = {};
    // validate values between invoices
    if (tabs.length > 1) {
      const prevTabs = tabs.filter((_, index) => index !== tabValue);
      const agencyfeeRate =
        prevTabs.reduce((acc, curr) => acc + (curr?.agencyFeesRate || 0), 0) +
        (Number(formValue?.agencyFeesRate) || 0);
      const adminFees =
        prevTabs.reduce((acc, curr) => acc + (curr?.adminFees || 0), 0) +
        (Number(formValue?.adminFees) || 0);
      const listingCommission =
        prevTabs.reduce(
          (acc, curr) => acc + (curr?.listingCommission || 0),
          0
        ) + (Number(formValue?.listingCommission) || 0);
      const deduction =
        prevTabs.reduce((acc, curr) => acc + (curr?.deduction || 0), 0) +
        (Number(formValue?.deduction) || 0);
      const telesalesCommission =
        prevTabs.reduce(
          (acc, curr) => acc + (curr?.telesalesCommission || 0),
          0
        ) + (Number(formValue?.telesalesCommission) || 0);
      const coordinatorCommission =
        prevTabs.reduce(
          (acc, curr) => acc + (curr?.coordinatorCommission || 0),
          0
        ) + (Number(formValue?.coordinatorCommission) || 0);
      const tlCommissionRate =
        prevTabs.reduce((acc, curr) => acc + (curr?.tlCommissionRate || 0), 0) +
        (Number(formValue?.tlCommissionRate) || 0);
      const smCommissionRate =
        prevTabs.reduce((acc, curr) => acc + (curr?.smCommissionRate || 0), 0) +
        (Number(formValue?.smCommissionRate) || 0);
      if (agencyfeeRate > 100) {
        errors.agencyFeesRate = translate(
          "error-agent-commission-rate-max-multiple"
        );
      }
      if (adminFees > finalNetAmount) {
        errors.adminFees = translate("error-admin-fees-max-multiple");
      }
      if (listingCommission > finalNetAmount) {
        errors.listingCommission = translate(
          "error-listing-commission-max-multiple"
        );
      }
      if (deduction > finalNetAmount) {
        errors.deduction = translate("error-deduction-max-multiple");
      }
      if (telesalesCommission > finalNetAmount) {
        errors.telesalesCommission = translate(
          "error-telesales-commission-max-multiple"
        );
      }
      if (coordinatorCommission > finalNetAmount) {
        errors.coordinatorCommission = translate(
          "error-coordinator-commission-max-multiple"
        );
      }
      if (tlCommissionRate > 100) {
        errors.tlCommissionRate = translate(
          "error-tl-commission-rate-max-multiple"
        );
      }
      if (smCommissionRate > 100) {
        errors.smCommissionRate = translate(
          "error-sm-commission-rate-max-multiple"
        );
      }
    }
    if (selectedTransaction?.transactionID) {
      if (formValue.agentCommissionRate > 100)
        errors.agentCommissionRate = translate(
          "error-agent-commission-rate-max"
        );
      if (formValue.deduction > selectedTransaction.finalNetAmount)
        errors.deduction = translate("deduction-amount-error");
      if (formValue.listingCommission > finalNetAmount)
        errors.listingCommission = translate("listing-commission-error");
      if (formValue.smCommissionRate > 100)
        errors.smCommissionRate = translate("sm-commission-rate-nested-error");
      if (formValue.telesalesCommission > finalNetAmount)
        errors.telesalesCommission = translate("telesales-commission-error");
      if (formValue.tlCommissionRate > 100)
        errors.tlCommissionRate = translate("tl-commission-rate-error");
      if (formValue.adminFees > finalNetAmount)
        errors.adminFees = translate("admin-fees-error");
      if (formValue.coordinatorCommission > finalNetAmount)
        errors.coordinatorCommission = translate(
          "coordinator-commission-error"
        );
      if (formValue?.agencyFeesRate > 100)
        errors.agencyFeesRate = translate("agent-commission-rate-error");
      if (Object.keys(formValue).length !== 15) {
        errors.general = translate("error-all-fields-required");
      }
      if (
        Object.values(formValue).some(
          (value) => Number.isNaN(value) || value === undefined
        )
      ) {
        errors.general = translate("error-all-fields-required");
      }
      if (Object.keys(errors).length === 0) {
        setIsInvouiceValid(true);
      } else {
        setIsInvouiceValid(false);
      }
    }
    return errors;
  };
  useEffect(() => {
    //reset tab index when selectedTransaction changes
    if (selectedTransaction) {
      setTabValue(0);
    }
  }, [selectedTransaction]);
  const handleRemoveTab = (idx) => {
    if (idx !== 0) {
      const newTabs = tabs.filter((_, i) => i !== idx);
      setTabs(newTabs);
      // Adjust tabValue to the previous tab if present, or default to the first tab
      setTabValue((prev) => {
        if (prev === idx) {
          return idx - 1 >= 0 ? idx - 1 : 0;
        }
        return prev > idx ? prev - 1 : prev;
      });
    }
  };
  return (
    <Box
      className={clsx(styles.nestedSideMenuRoot, { [styles.hidden]: !isOpen })}
    >
      <Box className={styles.invoiceTabs}>
        {tabs?.length > 0 && (
          <>
            <Tabs
              tabs={tabs}
              value={tabValue}
              onChange={handleTabChange}
              onAdd={handleAddTab}
              onRemove={handleRemoveTab}
            />
            {tabs.map((tab, idx) => (
              <TabPanel
                key={tab.agentAchievementCommissionInvoiceId}
                value={tabValue}
                index={idx}
              >
                <Invoice
                  selectedTransaction={selectedTransaction}
                  data={tab}
                  onSave={onSave}
                  index={idx}
                  validateFields={validateFields}
                  formValue={formValue}
                  setFormValue={setFormValue}
                  isOpen={isOpen}
                />
              </TabPanel>
            ))}
          </>
        )}
      </Box>
    </Box>
  );
}

export default AgentCommissionNestedMenu;
